// extracted by mini-css-extract-plugin
export var container = "autocomplete-module--container--d911c";
export var suggestionsContainer = "autocomplete-module--suggestionsContainer--93c40";